import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import * as helper from "../../utils/helper";
import * as API from "../../utils/apis";
import { logout } from "../../redux/actions/logoutAction";
import BoxCard from "../../components/BoxCard";
import InputText from "../../components/InputText";
import InputSelect from "../../components/InputSelect";
import InputDatePicker from "../../components/InputDatePicker";
import DataTableNodata from "../../components/DataTableNodata";
import Breadcrumb from "../../components/Breadcrumb";
import DataTable from "../../components/DataTable";
import {
  useMasterData,
  useOptionsListYears,
  useCurrentYear,
} from "../../components/hooks/useMasterData";
import ButtonReportLink from "../../components/ButtonReportLink";

const MySwal = withReactContent(Swal);

function Keep_Example() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login.result);
  const history = useHistory();
  const { t, i18n } = useTranslation(["common", "footer"]);

  const initialForm = {
    typeUser: "1",
    agency: "",

    dateBegin: "",
    dateEnd: "",
    outbreakId: "",
    animalTypeId: "",
    provinceId: "",
    districtId: "",
    subDistrictId: "",
    zoneId: "",
    caseCode: "",
    foundDiseaseTypeId: "",
    test_results: "",

    limit: 10,
    page: 1,
    totalPages: 1,
    sortDir: "DESC",
    sortBy: "id",
    totalElements: 0,
    numberOfElements: 0,
    headTitle: [
      {
        sortBy: "id",
        name: "ลำดับ",
        sortFlg: false,
      },
      {
        sortBy: "keepSampleDate",
        name: "วันที่เก็บตัวอย่าง",
        sortFlg: true,
      },

      {
        sortBy: "labName",
        name: "สถานที่ส่งตัวอย่าง",
        sortFlg: true,
      },
      {
        sortBy: "sendSampleDate",
        name: "วันที่ส่งตัวอย่าง",
        sortFlg: true,
      },
      {
        sortBy: "statusName",
        name: "ผลการทดสอบโรค",
        sortFlg: true,
      },

      {
        sortBy: "diseaseName",
        name: "ชนิดโรคที่พบ",
        sortFlg: true,
      },

      {
        sortBy: "updateName",
        name: "ผู้บันทึกผล",
        sortFlg: true,
      },

      {
        name: "จัดการ",
        sortFlg: false,
      },
    ],

    statusSampleId: [
      {
        id: 1,
        color: "#FF482F",
        status: "พบโรค",
      },
      {
        id: 2,
        color: "#25B881",
        status: "ไม่พบโรค",
      },
      {
        id: 3,
        color: "#C8CED3",
        status: "รอผลการตรวจ",
      },
    ],
  };
  const [form, setForm] = useState(initialForm);

  const [listExample, setListExample] = useState([]);

  // select จังหวัด ตำบล อำเภอ หมู่บ้าน
  const [provinceSelectValue, setProvinceSelectValue] = useState([]);
  const [provinceList, setProvinceList] = useState([]);

  const [districtSelectValue, setDistrictSelectValue] = useState([]);
  const [districtList, setDistrictList] = useState([]);

  const [subDistrictSelectValue, setSubDistrictSelectValue] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);

  const [isClearSearch, setIsClearSearch] = useState(false);

  // select  เขตปศุสัตว์ ชนิดสัตว์

  const [zoneLivestockSelectValue, setZoneLivestockSelectValue] = useState([]);
  const [zoneLivestockList, setZoneLivestockList] = useState([]);

  const [animalSelectValue, setAnimalSelectValue] = useState([]);
  const [animalList, setAnimalList] = useState([]);

  const [diseaseFoundSelectValue, setDiseaseFoundSelectValue] = useState([]);
  const [diseaseFoundList, setDiseaseFoundList] = useState([]);

  const initTestResultsSelectValue = [];
  const [testResultsTypeSelectValue, setTestResultsValue] = useState(
    initTestResultsSelectValue
  );
  const selectTestResultsList = [
    { value: "1", label: "พบโรค" },
    { value: "2", label: "ไม่พบโรค" },
  ];
  const [testResultsList, setTestResultsList] = useState(selectTestResultsList);

  const breadcrumbPath = [
    { path: "/home", name: "หน้าหลัก" },
    { path: "/passive_surv/disease_report", name: "การเฝ้าระวังเชิงรับ" },
    { path: "/passive_surv/keep-example", name: "เก็บตัวอย่าง/ผลตรวจ" },
    {
      path: "active",
      name: "รายการการทดสอบโรค (เก็บตัวอย่าง) และผลการตรวจทางห้องปฏิบัติการ",
    },
  ];

  const [provinceByZoneId, setProvinceByZoneId] = useState(null);
  useMasterData("province", provinceList, setProvinceList, provinceByZoneId);
  useMasterData(
    "zoneLivestock",
    zoneLivestockList,
    setZoneLivestockList,
    provinceByZoneId
  );

  const optionsListYear = useOptionsListYears();
  const currentYearValue = useCurrentYear();
  const [yearFilterList, setYearFilterList] = useState(currentYearValue);

  useEffect(() => {
    getSample();
  }, [form.limit, form.page, form.sortBy, form.sortDir, isClearSearch]);

  useEffect(() => {
    // getProvince();
    getAnimal();
    getDiseaseFound();
    getZoneLivestock();
  }, []);

  const getSample = async () => {
    const params = await {
      sortBy: form.sortBy ? form.sortBy : "",
      sortDir: form.sortDir ? form.sortDir : "",
      page: form.page ? form.page : "",
      limit: form.limit ? form.limit : "",
      obCode: form.outbreakId ? form.outbreakId : "",
      caseCode: form.caseCode ? form.caseCode : "",
      dateBegin: form.dateBegin ? helper.getDate(form.dateBegin) : "",
      dateEnd: form.dateEnd ? helper.getDate(form.dateEnd) : "",
      zoneId: form.zoneId ? form.zoneId : "",
      provinceId: form.provinceId ? form.provinceId : "",
      amphurId: form.districtId ? form.districtId : "",
      tambonId: form.subDistrictId ? form.subDistrictId : "",
      animalTypeId: form.animalTypeId ? form.animalTypeId : "",
      statusId: form.test_results ? form.test_results : "",
      diseaseName: form.foundDiseaseTypeId ? form.foundDiseaseTypeId : "",
      onYear: yearFilterList?.value - 543 ?? new Date().getFullYear(),
    };

    try {
      const response = await API.getSample(params);
      const data = await response.data;
      // console.log("params---getSample--🐳🐳", params, response);

      if (response.status === 200) {
        await setForm({
          ...form,
          totalPages: data.totalPages,
          totalElements: data.totalElements,
          numberOfElements: data.numberOfElements,
        });
        await setListExample(data.content);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(logout({ history }));
      }
      console.log(error);
    }
  };

  const getProvince = async (countyId) => {
    try {
      const req = {
        id: "",
        statusId: 1,
        page: "1",
        limit: "100",
        search: "",
        sortBy: "id",
        sortDir: "ASC",
        zoneId: countyId,
      };
      const response = await API.getProvinces(req);
      // const response = await API.getProvince();
      const data = await response.data;
      if (response.status === 200) {
        let provincesArray = [];
        data.content.forEach((element) => {
          provincesArray.push({
            value: element.id,
            label: element.name,
          });
        });
        setProvinceByZoneId(provincesArray);
        setProvinceList(provincesArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDistricts = async (id) => {
    try {
      const response = await API.getDistricts("", id);
      const data = await response.data;
      if (response.status === 200) {
        let districtArray = [];
        data.content.forEach((element) => {
          districtArray.push({
            value: element.id,
            label: element.name,
          });
        });
        setDistrictList(districtArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSubDistricts = async (id) => {
    try {
      const response = await API.getSubDistricts("", id);
      const data = await response.data;
      if (response.status === 200) {
        let subDistrictArray = [];
        data.content.forEach((element) => {
          subDistrictArray.push({
            value: element.id,
            label: element.name,
            zipcode: element.zipcode,
          });
        });
        setSubDistrictList(subDistrictArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getZoneLivestock = async () => {
    try {
      const response = await API.getZoneLivestock();
      const data = await response.data;
      if (response.status === 200) {
        let zoneArray = [];
        data.content.forEach((element) => {
          zoneArray.push({
            value: element.id,
            label: element.name,
          });
        });
        await setZoneLivestockList(zoneArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAnimal = async () => {
    try {
      const response = await API.getAnimal("", 1);
      const data = await response.data;
      if (response.status === 200) {
        let animalArray = [];
        data.content.forEach((element) => {
          animalArray.push({
            value: element.id,
            label: element.name,
          });
        });
        await setAnimalList(animalArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDiseaseFound = async () => {
    try {
      const response = await API.getDiseaseType("", "", 1, 100, 1);
      const data = await response?.data;
      if (response.status === 200) {
        let diseaseArray = [];
        data.content.forEach((element) => {
          diseaseArray.push({
            value: element.id,
            label: element.name,
          });
        });
        setDiseaseFoundList(diseaseArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const selectValueProvince = (value) => {
    setProvinceSelectValue([value]);
    setDistrictSelectValue([]);
    setSubDistrictSelectValue([]);
    setForm({ ...form, provinceId: value.value });
    getDistricts(value.value);
  };

  const selectValueDistrict = (value) => {
    setDistrictSelectValue([value]);
    setSubDistrictSelectValue([]);
    setForm({ ...form, districtId: value.value });
    getSubDistricts(value.value);
  };

  const selectValueSubDistrict = (value) => {
    setSubDistrictSelectValue([value]);
    setForm({ ...form, subDistrictId: value.value });
  };

  const toSearch = async () => {
    setForm({ ...form, page: 1 });
    setIsClearSearch(!isClearSearch);
  };

  const clearSearch = () => {
    setForm(initialForm);
    setProvinceSelectValue([]);
    setDistrictSelectValue([]);
    setSubDistrictSelectValue([]);
    setDistrictList([]);
    setSubDistrictList([]);
    setAnimalSelectValue([]);
    setZoneLivestockSelectValue([]);
    setDiseaseFoundSelectValue([]);
    setTestResultsValue([]);
    setIsClearSearch(!isClearSearch);
  };

  const getFilter = (type, isChange1, isChange2) => {
    if (type === "page") {
      setForm({
        ...form,
        page: isChange1,
      });
    } else if (type === "limit") {
      setForm({
        ...form,
        limit: isChange1,
        page: 1,
      });
    } else {
      setForm({
        ...form,
        sortBy: isChange1,
        sortDir: isChange2,
        page: 1,
      });
    }
  };

  const getStatusColor = (idStatus) => {
    let statusColor;
    if (form.statusSampleId && form.statusSampleId.length > 0) {
      form.statusSampleId.map((item, index) => {
        if (item.id === idStatus) {
          statusColor = (
            <div className="d-flex justify-content-center">
              <div
                style={{ background: item.color }}
                className="box-status font14 px-2 text-center text-white"
              >
                <span>{item.status}</span>
              </div>
            </div>
          );
        }
      });
    }
    return statusColor;
  };

  const buttonSearch = () => {
    return (
      <>
        <ButtonReportLink path={"keep_example"} linkSize={4} addIndex params={{
          obCode: form.outbreakId ? form.outbreakId : "",
          caseCode: form.caseCode ? form.caseCode : "",
          dateBegin: form.dateBegin ? helper.getDate(form.dateBegin) : "",
          dateEnd: form.dateEnd ? helper.getDate(form.dateEnd) : "",
          zoneId: form.zoneId ? form.zoneId : "",
          provinceId: form.provinceId ? form.provinceId : "",
          amphurId: form.districtId ? form.districtId : "",
          tambonId: form.subDistrictId ? form.subDistrictId : "",
          animalTypeId: form.animalTypeId ? form.animalTypeId : "",
          statusId: form.test_results ? form.test_results : "",
          diseaseName: form.foundDiseaseTypeId ? form.foundDiseaseTypeId : "",
          onYear: yearFilterList?.value - 543 ?? new Date().getFullYear(),
        }}/>
        <button
          className="btn btn-danger mr-2"
          onClick={() => {
            clearSearch();
            setProvinceByZoneId(null);
          }}
        >
          ล้างข้อมูล
        </button>
        <button className="btn btn-success" onClick={() => toSearch()}>
          {t("search")}
        </button>
      </>
    );
  };

  const buttonAdd = () => {
    return (
      <button
        className="btn btn-info "
        disabled={user?.userGroup.mcreate === "n"}
        onClick={() => history.push(`/passive_surv/keep-example/save`)}
      >
        <a className="text-white">
          <i className="fas fa-plus mr-1 "></i>เพิ่มการทดสอบโรค
        </a>
      </button>
    );
  };

  const viewDetails = (id) => {
    history.push(`/passive_surv/keep-example/edit/${id}`);
  };
  const duplicate = (id) => {
    history.push(`/passive_surv/keep-example/duplicate/${id}`);
  };

  const deleteEx = (id) => {
    MySwal.fire({
      text: `ยืนยันที่จะลบรายการการทดสอบโรค (เก็บตัวอย่าง) และผลการตรวจทางห้องปฏิบัติการ`,
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ตกลง",
    }).then(async (result) => {
      if (result.value) {
        try {
          const response = await API.deleteSample(id);
          if (response.status === 200) {
            await getSample();
          }
        } catch (error) {
          if (error.response && error.response.status === 401) {
            dispatch(logout({ history }));
          } else {
            MySwal.fire({
              text: `ลบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง`,
              icon: "warning",
              confirmButtonText: "ตกลง",
            });
          }
          console.log("error", error);
        }
      }
    });
  };

  const renderTable = (data) => {
    if (data.length > 0) {
      return data.map((item, i) => (
        <tr key={i} className="font14 fitwidth text-center">
          <td>{form.limit * (form.page - 1) + (i + 1)}</td>
          <td className="text-center">
            {item.keepSampleDate
              ? helper.momentDate(item.keepSampleDate, "th", "short")
              : "-"}
          </td>
          <td className="text-center">{item.labName ? item.labName : "-"}</td>
          <td className="text-center">
            {item.sendSampleDate
              ? helper.momentDate(item.sendSampleDate, "th", "short")
              : "-"}
          </td>
          <td className="text-center">
            {item.statusId ? getStatusColor(item.statusId) : "-"}
          </td>
          <td className="text-center">
            {item.diseaseName ? item.diseaseName : "-"}
          </td>
          <td>
            <span className="font12">
              {helper.momentDate(item.updateDate, "th", "short")}
            </span>{" "}
            <br />
            {item.updateName ? `(${item.updateName})` : ""}
          </td>
          <td>
            <div className="d-flex justify-content-center border-0 ">
              <button
                className="btn btn-add mr-2 "
                onClick={() => viewDetails(item.id)}
                disabled={
                  user?.userGroup.mupdate === "n" &&
                  user?.userGroup.mview === "n"
                }
              >
                <img className="icon-btn " src="/svg/btn-edit.svg" alt="edit" />
              </button>
              <button
                className="btn btn-del mr-2 "
                onClick={() => deleteEx(item.id)}
                disabled={user?.userGroup.mdelete === "n"}
              >
                <img className="icon-btn " src="/svg/btn-del.svg" alt="del" />
              </button>
              <button
                className="btn btn-copy mr-2 "
                onClick={() => duplicate(item.id)}
              >
                <img
                  className=" icon-btn "
                  src="/svg/btn-copy.svg"
                  alt="copy"
                />
              </button>
            </div>
          </td>
        </tr>
      ));
    } else {
      return <DataTableNodata colSpan="9" />;
    }
  };

  return (
    <div className="">
      <div className="pl-4 bg-white ml30">
        <Breadcrumb data={breadcrumbPath} />
      </div>

      <div className="bg-gray-light">
        <div className="px-4 pt-3 container-fixed-footer">
          <BoxCard title="ตัวกรอง" classLabel="" headRight={buttonSearch()}>
            <div className=" ">
              <Row className="mb-2 pl-2 ">
                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputSelect
                    title="ปี"
                    star={false}
                    placeholder="กรุณาเลือก"
                    idName="year"
                    classLabel="normal"
                    selectValue={yearFilterList}
                    optionsList={optionsListYear}
                    handleChange={(value) => setYearFilterList(value)}
                  />
                </Col>
                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputText
                    type="text"
                    title="เลข Outbreak ID"
                    idName="outbreakId"
                    value={form.outbreakId}
                    star={false}
                    placeholder="โปรดระบุ"
                    classLabel="normal"
                    handleChange={(value) =>
                      setForm({ ...form, outbreakId: value })
                    }
                  />
                </Col>

                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputText
                    type="text"
                    title="เลข case ID"
                    idName="caseCode"
                    value={form.caseCode}
                    star={false}
                    placeholder="โปรดระบุ"
                    classLabel="normal"
                    handleChange={(value) =>
                      setForm({ ...form, caseCode: value })
                    }
                  />
                </Col>

                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputDatePicker
                    title="วันที่ปฏิบัติงาน"
                    classLabel="normal"
                    placeholder="วัน/เดือน/ปี"
                    value={form.dateBegin}
                    star={false}
                    handleChange={(value) =>
                      setForm({ ...form, dateBegin: value })
                    }
                  />
                </Col>

                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputDatePicker
                    title="ถึงวันที่"
                    classLabel="normal"
                    placeholder="วัน/เดือน/ปี"
                    value={form.dateEnd}
                    star={false}
                    handleChange={(value) =>
                      setForm({ ...form, dateEnd: value })
                    }
                  />
                </Col>

                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputSelect
                    title="ชื่อโรคที่พบ"
                    star={false}
                    placeholder="กรุณาเลือก"
                    idName="title"
                    classLabel="normal"
                    selectValue={diseaseFoundSelectValue}
                    optionsList={diseaseFoundList}
                    handleChange={(value) => {
                      setDiseaseFoundSelectValue([value]);
                      setForm({ ...form, foundDiseaseTypeId: value.value });
                    }}
                  />
                </Col>
              </Row>

              <Row className="mb-2 pl-2  ">
                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputSelect
                    title="เขตปศุสัตว์"
                    star={false}
                    placeholder="กรุณาเลือก"
                    idName="title"
                    classLabel="normal"
                    selectValue={zoneLivestockSelectValue}
                    optionsList={zoneLivestockList}
                    handleSelectValue={(value) => {
                      setZoneLivestockSelectValue([
                        { value: value.value, label: value.label },
                      ]);
                      getProvince(value.value);
                    }}
                    handleChange={(value) =>
                      setForm({ ...form, zoneId: value.value })
                    }
                  />
                </Col>

                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputSelect
                    title="จังหวัด"
                    star={false}
                    placeholder="กรุณาเลือก"
                    idName="province"
                    classLabel="normal"
                    selectValue={provinceSelectValue}
                    optionsList={provinceList}
                    handleChange={(value) => {
                      selectValueProvince(value);
                      setForm({ ...form, provinceId: value.value });
                    }}
                  />
                </Col>

                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputSelect
                    title="อำเภอ"
                    star={false}
                    placeholder="กรุณาเลือก"
                    idName="title"
                    classLabel="normal"
                    selectValue={districtSelectValue}
                    optionsList={districtList}
                    handleChange={(value) => {
                      selectValueDistrict(value);
                      setForm({ ...form, districtId: value.value });
                    }}
                  />
                </Col>

                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputSelect
                    title="ตำบล"
                    star={false}
                    placeholder="กรุณาเลือก"
                    idName="subDistrict"
                    classLabel="normal"
                    selectValue={subDistrictSelectValue}
                    optionsList={subDistrictList}
                    handleChange={(value) => {
                      selectValueSubDistrict(value);
                      setForm({ ...form, subDistrictId: value.value });
                    }}
                  />
                </Col>

                <Col lg={2} md={6} sm={12} xs={12}>
                  <InputSelect
                    title="ชนิดสัตว์"
                    star={false}
                    placeholder="กรุณาเลือก"
                    idName="title"
                    classLabel="normal"
                    selectValue={animalSelectValue}
                    optionsList={animalList}
                    handleChange={(value) => {
                      setAnimalSelectValue([value]);
                      setForm({ ...form, animalTypeId: value.value });
                    }}
                  />
                </Col>

                <Col lg={2} md={2} sm={6}>
                  <InputSelect
                    title="ผลการตรวจโรค"
                    star={false}
                    placeholder="กรุณาเลือก"
                    idName="title"
                    classLabel="normal"
                    selectValue={testResultsTypeSelectValue}
                    optionsList={testResultsList}
                    handleChange={(value) => {
                      setTestResultsValue(value);
                      setForm({ ...form, test_results: value.value });
                    }}
                  />
                </Col>
              </Row>
            </div>
          </BoxCard>
          <BoxCard
            classNameBox="mt-3"
            title="รายการการทดสอบโรค (เก็บตัวอย่าง) และผลการตรวจทางห้องปฏิบัติการ"
            headRight={buttonAdd()}
          >
            <DataTable
              typeTable="colSpan"
              headColumns={form.headTitle}
              totalPages={form.totalPages}
              page={form.page}
              limit={form.limit}
              sortDir={form.sortDir}
              sortBy={form.sortBy}
              getLimit={(limit) => getFilter("limit", limit)}
              getFilter={(sortBy, sortDir) =>
                getFilter("filter", sortBy, sortDir)
              }
              getPage={(page) => getFilter("page", page)}
              totalItems={form.totalElements}
              numberOfItems={form.numberOfElements}
            >
              {renderTable(listExample)}
            </DataTable>
          </BoxCard>
        </div>
      </div>
    </div>
  );
}

export default Keep_Example;
